import { getSourceQueryData } from '#pplx/frontend/apps/ask/sources/hooks/getSourceQueryData.js';
import { isSourceIdConnectedByMigration, isSourceAllowed as isSourceAllowedPredicate, isSourceConnected as isSourceConnectedPredicate, } from '#pplx/frontend/apps/ask/sources/hooks/sourceStatusPredicates.js';
import { sourceQueryOptions } from '#pplx/frontend/apps/ask/sources/queries/sourceQueryOptions.js';
import { useInfiniteQuery } from '#pplx/frontend/react-query/useInfiniteQuery.js';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
export const useApiSources = (params) => {
    const intl = useIntl();
    const query = useInfiniteQuery(sourceQueryOptions(params));
    const [sources, getSource, engineMode] = useMemo(() => getSourceQueryData({ data: query.data, intl }), [query.data, intl]);
    const isSourceAllowed = useCallback((sourceId) => {
        const source = getSource(sourceId);
        return source !== undefined && isSourceAllowedPredicate(source);
    }, [getSource]);
    const getIsSourceConnected = useCallback((sourceId) => {
        const source = getSource(sourceId);
        if (!source) {
            return isSourceIdConnectedByMigration(sourceId, sources);
        }
        return isSourceConnectedPredicate(source);
    }, [getSource, sources]);
    const { refetch } = query;
    const refetchSources = useCallback(() => {
        void refetch();
    }, [refetch]);
    return useMemo(() => ({
        sources,
        isSourcesLoading: query.isLoading,
        isSourcesError: query.isError,
        refetchSources,
        isSourceAllowed,
        getIsSourceConnected,
        getSource,
        hasNextPage: query.hasNextPage,
        fetchNextPage: query.fetchNextPage,
        isFetching: query.isFetching,
        isFetchingNextPage: query.isFetchingNextPage,
        isRefetching: query.isRefetching,
        isPlaceholderData: query.isPlaceholderData,
        engineMode,
    }), [
        sources,
        query.isLoading,
        query.isError,
        refetchSources,
        query.isFetchingNextPage,
        query.isRefetching,
        isSourceAllowed,
        getIsSourceConnected,
        getSource,
        query.hasNextPage,
        query.fetchNextPage,
        query.isFetching,
        query.isPlaceholderData,
        engineMode,
    ]);
};
//# sourceMappingURL=useApiSources.js.map